module.exports = __webpack_public_path__ + "img/auctions.fb96b08f.svg";